module.exports = __webpack_public_path__ + "static/media/login.ac53a275.jpeg";